import { render, staticRenderFns } from "./MADTemplate.vue?vue&type=template&id=b6770f02&scoped=true&"
import script from "./MADTemplate.vue?vue&type=script&lang=js&"
export * from "./MADTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MADTemplate.vue?vue&type=style&index=0&id=b6770f02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6770f02",
  null
  
)

export default component.exports